import { render } from "./ReadMoreText.vue?vue&type=template&id=e9b7f1ec&scoped=true"
import script from "./ReadMoreText.vue?vue&type=script&lang=js"
export * from "./ReadMoreText.vue?vue&type=script&lang=js"

import "./ReadMoreText.vue?vue&type=style&index=0&id=e9b7f1ec&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b7f1ec"]])

export default __exports__